// Pagina contacto (informacion de contacto de la empresa Gosén. publica)

import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Paper } from '@mui/material';
import { Column } from 'jspdf-autotable';

export default function ContactPage() {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    organizacion: "",
    mensaje: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    if (!form.nombre || !form.email || !form.organizacion || !form.mensaje) {
      alert("Los campos con * son obligatorios")
    }

    try {
      await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });

      alert("Mensaje enviado correctamente");
      setForm({ nombre: "", email: "", organizacion: "", mensaje: "" });

    } catch (err) {
      console.error(err);
      alert("Error al enviar");
    }
  };

  return (
    <>
      <Box sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
        mt: { xs: 4, md: 20 },
        px: 2
     }}
        >
       
 {/* INFO EMPRESA */}
        <Box
          sx={{
            p: 4,
            width: { xs: "100%", md: 500 },
            backgroundColor: "#fff",
            borderRadius: 2,
            boxShadow: 4,
          }}
        >
          <Typography variant='h5' mb={2}
            sx={{
              color: "#0A2647",
              fontWeight: "bold",
              fontSize: { xs: "1.2rem", md: "1.5rem" }
            }}
          >
            Empresa Privada de Seguridad Gosén S.A de C.V.
          </Typography>

          <Box display="flex" flexDirection="column" gap={3}>

            <Box display='flex' flexDirection="column" gap={0.5}>
              <Typography variant='body2' sx={{ fontSize: "1rem", color: "#575858" }}>Ceiba 14</Typography>
              <Typography variant='body2' sx={{ fontSize: "1rem", color: "#575858" }}>Col. Vista Hermosa</Typography>
              <Typography variant='body2' sx={{ fontSize: "1rem", color: "#575858" }}>55028, Ecatepec de Morelos</Typography>
              <Typography variant='body2' sx={{ fontSize: "1rem", color: "#575858" }}>Estado de México</Typography>
            </Box>

            <Box display='flex' flexDirection="column" gap={0.5}>
              <Typography variant='body2' sx={{ fontSize: "1rem", color: "#575858" }}>RFC: EPS160216IW9</Typography>
              <Typography variant='body2' sx={{ fontSize: "1rem", color: "#575858" }}>Correo Electrónico:</Typography>
              <Typography variant='body2' sx={{ fontSize: "1rem", color: "#575858" }}>Teléfono:</Typography>
              
            </Box>
          </Box>
        </Box>

        {/* FORMULARIO */}

        <Box 
          sx={{
            width: { xs: "100%", md: 500 }
          }}
       >
          <Paper sx={{
            p: 3,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: "#fff"
          }}>
            <Typography variant='h6' mb={2} 
              sx={{ mb: 1, color: '#144272', fontWeight: 'normal'
              }}
              >
              Contáctanos
            </Typography>

            <TextField
              label="Nombre"
              name='nombre'
              fullWidth
              required
              margin='normal'
              value={form.nombre}
              onChange={handleChange}
            />
            <TextField
              label="Correo electrónico"
              name='email'
              fullWidth
              required
              margin='normal'
              value={form.email}
              onChange={handleChange}
            />
            <TextField
              label="Compañia / Organización"
              name='organizacion'
              fullWidth
              margin='normal'
              value={form.compañia}
              onChange={handleChange}
            />
            <TextField
              label="Mensaje"
              name='mensaje'
              fullWidth
              required
              multiline
              rows={4}
              margin='normal'
              value={form.mensaje}
              onChange={handleChange}
            />

            <Typography
              sx={{
                color: "#989898",
                fontSize: "13px"
              }}
            >
              * Campos obligatorios
            </Typography>

            <Button
              variant='contained'
              fullWidth
              sx={{ 
                mt: 2, 
                backgroundColor: "#0A2647",
                color: "#fff",
                '&:hover': { backgroundColor: '#144272'
                }
              }}
              onClick={handleSubmit}
            >
              Enviar
            </Button>
          </Paper>
        </Box>
      </Box>
    </>
  );
}
